import React from "react";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import { Tag } from "antd";
import { omit, pick } from "lodash";

const AppliedFilters = props => {
  const qAll = props.fieldSelector(props.router.location.query); // don't show `sort` as a tag, already shown in table header
  const q = omit(qAll, props.omitQueryString);
  const qOmitted = pick(qAll, props.omitQueryString);
  const pathname = props.router.location.pathname;
  const keys = Object.keys(q);
  return keys.length ? (
    <div style={{ width: "100%", margin: 8 }}>
      <b>{`${props.title}: `}</b>
      {keys.map((k, i) => {
        const valueText = `${q[k]}`;
        return (
          <Tag closable={props.nonClosable.indexOf(k) < 0} color={props.tagColor} onClose={() => props.router.push({ pathname, query: { ...omit(qAll, k) } })} key={k + i}>
            <b>{`${props.fieldMapper(k)}: `}</b>
            {valueText.length > 50 ? `${valueText.substring(0, 50)}...` : valueText}
          </Tag>
        );
      })}
      <Tag onClick={() => props.router.push({ pathname, query: props.defaultQuery ? props.defaultQuery : qOmitted })}>{`${props.clearButtonText}`}</Tag>
    </div>
  ) : null;
};

AppliedFilters.propTypes = {
  fieldSelector: PropTypes.func.isRequired,
  fieldMapper: PropTypes.func.isRequired,
  omitQueryString: PropTypes.array,
  defaultQuery: PropTypes.object,
  tagColor: PropTypes.string,
  title: PropTypes.string,
  nonClosable: PropTypes.array,
  clearButtonText: PropTypes.string
};

AppliedFilters.defaultProps = {
  omitQueryString: ["sort"],
  title: "Applied Filters",
  nonClosable: [],
  clearButtonText: "Clear All"
};
export default withRouter(AppliedFilters);
